import { render, staticRenderFns } from "./SamplesModelDialog.vue?vue&type=template&id=4d351838&scoped=true"
import script from "./SamplesModelDialog.vue?vue&type=script&lang=ts"
export * from "./SamplesModelDialog.vue?vue&type=script&lang=ts"
import style0 from "./SamplesModelDialog.vue?vue&type=style&index=0&id=4d351838&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d351838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d351838')) {
      api.createRecord('4d351838', component.options)
    } else {
      api.reload('4d351838', component.options)
    }
    module.hot.accept("./SamplesModelDialog.vue?vue&type=template&id=4d351838&scoped=true", function () {
      api.rerender('4d351838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SamplesModelDialog.vue"
export default component.exports